import { Grid, Stack, styled } from "@mui/material";

export const MainStack = styled(Stack)(({ theme }) => ({
  height: "100%",
  width: "100%",
  display: "flex",
  backgroundColor: "#F3F4F7",
  padding: "140px 120px",
  [theme.breakpoints.down("lg")]: {
    padding: "60px 40px",
  },
}));

export const GridItemInfo = styled(Grid)(({ theme }) => ({
  backgroundColor: "#FAFCFE",
  [theme.breakpoints.down("lg")]: {
    display: "none",
  },
}));

export const GridItemForm = styled(Grid)(({ theme }) => ({
  backgroundColor: "#FFFFFF",
  padding: "47px 24px 0 24px",
  [theme.breakpoints.down("lg")]: {
    padding: "40px 40px 0 40px",
    width: "100%",
  },
}));

export const Logo = styled("img")(() => ({
  width: "180px",
}));
